import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/api";
import { MapPin, Clock, Laptop, Euro, CalendarDays } from "lucide-react";
import { CareersShell, KIND_STYLE } from "@/components/jobs/CareersShell";
import { JobApplicationForm } from "@/components/jobs/JobApplicationForm";

export default function CarriereOffre() {
  const { id } = useParams();
  const [offer, setOffer] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/public/jobs/${id}`).then((r) => setOffer(r.data)).catch((e) => setError(e.response?.data?.detail || "Offre introuvable"));
  }, [id]);

  if (error) {
    return (
      <CareersShell back={{ to: "/carrieres", label: "Toutes les offres" }}>
        <div className="bg-white border border-[#DEE2E6] p-10 text-center" data-testid="job-not-found">
          <div className="font-display font-black text-2xl">{error}</div>
        </div>
      </CareersShell>
    );
  }
  if (!offer) return <CareersShell back={{ to: "/carrieres", label: "Toutes les offres" }}><div className="text-sm text-[#868E96]">Chargement…</div></CareersShell>;

  const k = KIND_STYLE[offer.kind] || KIND_STYLE.emploi;
  const facts = [
    [Clock, offer.contract_label], [MapPin, offer.location], [Laptop, offer.remote !== "none" ? offer.remote_label : ""], [Euro, offer.salary_label],
    [CalendarDays, offer.deadline ? `Jusqu'au ${new Date(offer.deadline).toLocaleDateString("fr-FR")}` : ""],
  ].filter(([, v]) => v);

  return (
    <CareersShell back={{ to: "/carrieres", label: "Toutes les offres" }}>
      <div className="grid lg:grid-cols-[1fr_440px] gap-10 items-start">
        <article data-testid="job-detail">
          <div className="flex items-center gap-3 mb-4">
            <span className={`text-[9px] uppercase tracking-[0.25em] font-bold px-2 py-1 ${k.cls}`} data-testid="job-kind">{k.label}</span>
            <span className="text-[10px] font-mono text-[#868E96]">{offer.reference}</span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter" data-testid="job-title">{offer.title}</h1>
          <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-sm text-[#495057]">
            {facts.map(([Icon, v]) => <span key={v} className="inline-flex items-center gap-1.5"><Icon className="h-4 w-4 text-[#002FA7]" />{v}</span>)}
          </div>
          {offer.skills?.length > 0 && (
            <div className="mt-5 flex flex-wrap gap-1.5" data-testid="job-skills">
              {offer.skills.map((s) => <span key={s} className="text-[11px] px-2 py-1 border border-[#DEE2E6] bg-white">{s}</span>)}
            </div>
          )}
          <div className="mt-8 bg-white border border-[#DEE2E6] p-6 lg:p-8">
            <div className="legal-prose" data-testid="job-description" dangerouslySetInnerHTML={{ __html: offer.description_html || "" }} />
          </div>
          {offer.kind === "business_partner" && (
            <div className="mt-6 border-l-4 border-[#FFD700] bg-[#FFFBEB] p-4 text-sm text-[#495057]" data-testid="job-bp-notice">
              <b>Mandat indépendant :</b> le Business Partner exerce sous son propre SIRET (micro-entreprise, société…). Le numéro SIRET est obligatoire pour postuler ;
              il est vérifié automatiquement (14 chiffres + clé de contrôle).
            </div>
          )}
        </article>
        <aside className="lg:sticky lg:top-6">
          <JobApplicationForm offer={offer} />
        </aside>
      </div>
    </CareersShell>
  );
}
